import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "header-light-dark settings-btn header-dark-btn",
    id: "header-light-dark",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOnlyHeaderDarkMode && _ctx.toggleOnlyHeaderDarkMode(...args)))
  }, _cache[1] || (_cache[1] = [
    _createTextVNode(" Click To "),
    _createElementVNode("span", { class: "dark2" }, "Dark", -1),
    _createElementVNode("span", { class: "light2" }, "Light", -1)
  ])))
}